import moment from 'moment';

import { DISPLAY_DATE_FORMAT, DATE_FORMAT, MILLION } from '@/consts';
import contractDetailServices from '@/views/ContractDetail/ContractDetailServices';

import {
  SET_CONTRACT,
  SET_CLIENT,
} from './types';

export default {
  async getContractRenewInfo({ commit }, id) {
    const [contractData, clientData] = await Promise.all([
      contractDetailServices.getContractDetail(id),
      contractDetailServices.getClientDetailByContractId(id),
    ]);

    let summaryData;
    if (contractData.active) {
      summaryData = await contractDetailServices.getContractSummaryByMifosId(id);
    } else {
      const contract = {
        active: false,
        mifosId: contractData.mifosId,
        status: contractData.status,
      };
      commit(SET_CONTRACT, contract);
      return;
    }

    const contract = {
      id: contractData.id,
      mifosId: contractData.mifosId,
      order: contractData.order,
      active: contractData.active,
      status: contractData.status,
      asset: contractData.asset,
      assetType: contractData.assetType,
      maturesDate: moment().format(DISPLAY_DATE_FORMAT),
      oldTotalRepayment: summaryData.totalRepayment / MILLION,
      oldTotalWaived: summaryData.totalWaived / MILLION,
      oldPenaltyChargesCharged: summaryData.penaltyChargesCharged / MILLION,
      oldDueDate: contractData.dueDate,
      product: contractData.product,
      storage: contractData.storage,
      oldProductRepayEvery: contractData.product.repayEvery,
      source: contractData.source,
      requiredAmount: contractData.requiredAmount / MILLION,
      proposedAmount: contractData.proposedAmount / MILLION,
      principalAmount: contractData.principalAmount / MILLION,
      oldInterestAmount: contractData.interestAmount / MILLION,
      interestAmount: contractData.interestAmount / MILLION,
      specialInterestValue: contractData.specialInterestValue,
      promotionAmount: contractData.promotionAmount / MILLION,
      oldApprovedAmount: contractData.approvedAmount / MILLION,
      approvedAmount: contractData.approvedAmount / MILLION,
      diffAmount: contractData.diffAmount ? contractData.diffAmount / MILLION : 0,
      warehousingFee: contractData.warehousingFee / MILLION,
    };

    const client = {
      id: clientData.id,
      mifosId: clientData.mifosId,
      name: clientData.name,
      primaryPhone: clientData.primaryPhone,
      alternativePhone: clientData.alternativePhone,
      dateOfBirth: moment(clientData.dateOfBirth, DATE_FORMAT).format(DISPLAY_DATE_FORMAT),
      nationalId: clientData.nationalId,
      address: clientData.address,
      district: clientData.district,
      city: clientData.city,
    };

    commit(SET_CONTRACT, contract);
    commit(SET_CLIENT, client);
  },

  setContract({ commit }, info) {
    commit(SET_CONTRACT, info);
  },

  setClient({ commit }, info) {
    commit(SET_CLIENT, info);
  },
};
